import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import artwork from '@assets/images/error-artwork.svg'

import CustomLink from '../customLink'
import Head from 'next/head'
import { SITE_NAME } from '@shared-submodule/sm-constants'

const MyImage = dynamic(() => import('@shared/components/myImage'))

function PageError({ title = 'Oops! Something went wrong' }) {
  return (
    <>
      <Head>
        <title>{SITE_NAME}</title>
      </Head>
      <section
        className={`${styles.pageError} common-section d-flex justify-content-center align-items-center text-center text-secondary text-center`}>
        <div>
          <h1 className="mb-0">{title}. </h1>
          <div className={`${styles.artwork} mx-auto my-3 my-md-4`}>
            <MyImage src={artwork} width="162" height="162" alt="post" layout="responsive" />
          </div>
          <h5>It is a long established fact that a reader will be distracted by the readable content.</h5>
          <CustomLink href="/">
            <a className={`${styles.btn} theme-btn mt-2`}>Read Top Articles</a>
          </CustomLink>
        </div>
      </section>
    </>
  )
}
PageError.propTypes = {
  title: PropTypes.string
}
export default PageError
